import React, { useState, useCallback, useRef } from "react";
import { connect } from "react-redux";
import "../../../../../om/css/salesorder.css";
import AccordionReact from 'devextreme-react/accordion';
import FormField from '../../../../../dynamicFormBuilder/FormField';
import Toolbar, { Item } from "devextreme-react/toolbar";
import { Button } from 'devextreme-react/button';
import { SearchLayout } from '../../../../../im/codes/locationDataEntry/Layout';
import { WM } from '../../../../../const/constants';

const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];

// Mirrors the Location Data Entry search form (all fields default null so FillFilters skips them).
const initialFormFields = {
    IdentityId: null,
    LocationCode: null,
    Description: null,
    MinPositionIndex: null,
    MaxPositionIndex: null,
    CapacityAreaLimitFlag: null,
    CapacityArea: null,
    CapacityUnits: null,
    CapacityVolume: null,
    ClassCode: null,
    SubClassCode: null,
    UserDefinedCode1: null,
    UserDefinedCode2: null,
    UserDefinedCode3: null,
    UserDefinedCode4: null,
    UserDefinedCode5: null,
    UserDefinedCode6: null,
    UserDefinedCode7: null,
    UserDefinedCode8: null,
    UserDefinedCode9: null,
    UserDefinedCode10: null,
    CreationUserId: null,
    CreationDateTime: null,
    UserDefinedDate1: null,
    UserDefinedDate2: null,
    UserDefinedDate3: null,
    UserDefinedDate4: null,
    UserDefinedDate5: null,
    UserDefinedDate6: null,
    UserDefinedDate7: null,
    UserDefinedDate8: null,
    UserDefinedDate9: null,
    UserDefinedDate10: null,
    Depth: null,
    ProfileDescription: null,
    Dimensions: null,
    Height: null,
    LastUpdatedDateTime: null,
    LastUpdateUserId: null,
    LocationType: null,
    MinimumUnits: null,
    MaximumUnits: null,
    ParentLocation: null,
    ParentLocationDescription: null,
    CapacityPieces: null,
    CapacityPiecesLimitFlag: null,
    ProfileCode: null,
    UserDefinedQuantity1: null,
    UserDefinedQuantity2: null,
    UserDefinedQuantity3: null,
    UserDefinedQuantity4: null,
    UserDefinedQuantity5: null,
    UserDefinedQuantity6: null,
    UserDefinedQuantity7: null,
    UserDefinedQuantity8: null,
    UserDefinedQuantity9: null,
    UserDefinedQuantity10: null,
    Record: null,
    UserDefinedReference1: null,
    UserDefinedReference2: null,
    UserDefinedReference3: null,
    UserDefinedReference4: null,
    UserDefinedReference5: null,
    UserDefinedReference6: null,
    UserDefinedReference7: null,
    UserDefinedReference8: null,
    UserDefinedReference9: null,
    UserDefinedReference10: null,
    Status: null,
    CapacityVolumeLimitFlag: null,
    Width: null,
    CapacityLimitFlag: null,
    CapacityContainerUnits: null,
    CapacityContainerLimitFlag: null,
    CapacityShippingUnits: null,
    CapacityShippingUnitsLimitFlag: null,
    CapacityGrossWeight: null,
    CapacityGrossWeightLimitFlag: null,
    CapacityNetWeight: null,
    CapacityNetWeightLimitFlag: null,
    Priority: null,
    Module: WM,
};

const ByLocationFilters = (props) => {
    const [selectedItems, setSelectedItems] = useState([searchpanel[0]]);
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const [formFields, setformFields] = useState(initialFormFields);
    const formRefs = useRef({});

    const handleSearch = (e) => {
        e.event.stopPropagation();
        props.searchData(formFields);
    };
    const handleReset = (e) => {
        e.event.stopPropagation();
        setformFields(initialFormFields);
        props.searchData(initialFormFields);
    };
    const handleFieldValueChanged = useCallback(() => { }, []);
    const handleFormLoad = useCallback(() => { }, []);

    return (
        <AccordionReact
            dataSource={searchpanel}
            collapsible={true}
            multiple={false}
            animationDuration={300}
            selectedItems={selectedItems}
            onSelectionChanged={e => { if (e.currentTarget === e.target) { setSelectedItems(e.component.option('selectedItems')); } }}
            itemTitleRender={() => (
                <Toolbar className="accordian-toolbar">
                    <Item location="before">
                        <div className="title">
                            <h6 style={{ color: window._env_.Color2 }}>Location Management - (By Location)</h6>
                        </div>
                    </Item>
                    <Item location="after">
                        <Button className="accordianButton" onClick={handleSearch} text="Search" type="default" />
                    </Item>
                    <Item location="after">
                        <Button className="accordianButton" onClick={handleReset} text="Reset" />
                    </Item>
                </Toolbar>
            )}
            itemRender={() => (
                <FormField
                    currrentUser={currentUser}
                    layoutId='f81748d5-ba82-48e3-adc4-f6722fcd9ac6'
                    layoutName='IMLocationDataEntrySearchForm'
                    defaultFormSchema={SearchLayout}
                    formFields={formFields}
                    setformFields={setformFields}
                    handleFieldValueChange={handleFieldValueChanged}
                    noSpacingBeforeFirstRow={true}
                    DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                    formRefs={formRefs}
                    onFormLoad={handleFormLoad}
                />
            )}
            id="accordion-container" className="accordion-height"
        />
    );
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(ByLocationFilters);
